import { render } from "./createOrder.vue?vue&type=template&id=4742ccf3&ts=true"
import script from "./createOrder.vue?vue&type=script&lang=ts"
export * from "./createOrder.vue?vue&type=script&lang=ts"

import "./createOrder.vue?vue&type=style&index=0&id=4742ccf3&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__